import { getFeatureConfig } from '@luna/feature-config';
import { selectMyProfileData } from '@shared/profile';

interface LuxCrossApplicationTrackingProperties {
    appId?: string;
    osFamily?: string;
    instituteId?: number;
    idLicenceHolder?: string;
    touchPoint?: string;
}

export function luxCrossApplicationTrackingProperties():
    | LuxCrossApplicationTrackingProperties
    | undefined {
    const appId = getFeatureConfig((f) => f.tracking?.appId);
    const instituteIdConfig = getFeatureConfig((f) => f.tracking?.instituteId);

    return {
        appId,
        osFamily: 'web',
        instituteId: instituteIdConfig ?? selectMyProfileData()?.instituteId ?? 0,
        idLicenceHolder: selectMyProfileData()?.companyInfo?.licenseHolder,
        touchPoint: 'george',
    };
}
